/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ticketingMgmt.vue?vue&type=template&id=5c65dc39&scoped=true"
import script from "./ticketingMgmt.vue?vue&type=script&lang=js"
export * from "./ticketingMgmt.vue?vue&type=script&lang=js"
import style0 from "./ticketingMgmt.vue?vue&type=style&index=0&id=5c65dc39&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c65dc39",
  null
  
)

export default component.exports